<template>
    <div class="carousel-cell">
        <router-link :to="'/movie-detail/' + movie.id">
            <div class="thumbnail-wrapper" :id="'i_3_' + index">
                <div class="thumbnail" v-bind:style="{ backgroundImage: 'url(' + movie.imageUrl + ')' }"></div>
            </div>
            <div class="carousel-title" v-html="movie.shortTitle"></div>
        </router-link>
    </div>
</template>


<script>
    export default {
        name: 'product',
        props: ['movie', 'index']
    }
</script>



// WEBPACK FOOTER //
// MovieTeaserDefault.vue?3a1c6c58